import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectUid} from "../../../slices/auth";
import {openDialog} from "../../../slices/dialog";
import {Collections} from "../../../api/collections";
import {deleteFile} from "../../../api/common";
import DeleteIcon from "@material-ui/icons/Delete";
import {EditCompanySection} from "../../CompanyComponents";
import EditIcon from "@material-ui/icons/Edit";
import ButtonCircle from "../../Common/ButtonCircle";
import {VideoPlayer} from "../../Common/VideoPlayer";
import "./AboutUs.scss";
import {useTranslation} from "react-i18next";

export const CardCompanyAboutUs = ({company, editable}) => {
    const uid = useSelector(selectUid);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onEditSection = (sectionId) => {
        dispatch(openDialog({
            Content: EditCompanySection,
            props: {
                company,
                sectionId
            },
            title: t("company_editSection_title"),
            closable: true
        }));
    };

    const onFileDelete = (fileId, section, typePath) => {
        deleteFile(`${uid}/profile/${typePath}/${fileId}`, `${section}.${typePath}.${fileId}`, `${Collections.USERS}/${uid}`);
    };

    return (
        <div className="companyAboutUs">
            {company && ["section1", "section2", "section3"].map(sectionId => <>
                {company[sectionId]?.title && <div className="card section">
                    <div className="header">
                        <div className="title">{company[sectionId]?.title}</div>
                        {editable && <ButtonCircle onClick={() => onEditSection(sectionId)}><EditIcon/></ButtonCircle>}
                    </div>
                    <div className="text pre-wrap" dangerouslySetInnerHTML={{__html: company[sectionId]?.text ?? ""}} />
                    <div className="files">
                        {Object.entries(company[sectionId]?.images || {}).map(entry => (
                            <div className="imageWrapper">
                                <div className="image" key={entry[0]} alt=''
                                     style={{backgroundImage: `url(${entry[1]})`}}>
                                    <div className="empty"></div>
                                    {editable && <ButtonCircle
                                        onClick={() => onFileDelete(entry[0], sectionId, "images")}><DeleteIcon/></ButtonCircle>}
                                </div>
                            </div>
                        ))}
                        {Object.entries(company[sectionId]?.videos || {}).map(entry => (
                            <div className="videoWrapper">
                                <VideoPlayer source={entry[1]}/>
                                {editable && <ButtonCircle
                                    onClick={() => onFileDelete(entry[0], sectionId, "videos")}><DeleteIcon/></ButtonCircle>}
                            </div>
                        ))}
                    </div>
                </div>}
                {!(company[sectionId]?.title) && editable && <div className="card card--inactive section">
                    <p>{t("company_noSection")}</p>
                    <div className="button-absolute">
                        <ButtonCircle onClick={() => onEditSection(sectionId)}><EditIcon/></ButtonCircle>
                    </div>
                </div>}
                {!(company[sectionId]?.title) && !editable && null}
            </>)}
        </div>
    );
}